/**
 * Created by emanuele on 31/01/2017.
 */
import React from 'react';
import {FormattedDate} from 'react-intl';

const LocalDayWithDayOfWeek = ({ data }) => (
    <FormattedDate
        value={data}
        day='2-digit'
        month='2-digit'
        year="numeric"
        weekday="long"
    />
);

export default LocalDayWithDayOfWeek;


/** WEBPACK FOOTER **
 ** ./src/components/LocalDayWithDayOfWeek.jsx
 **/